import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import '@/plugins/iview';

import SearchCard   from '@/components/SearchCard';
import ActionButtons   from '@/components/ActionButtons';
import FileUploader   from '@/components/FileUploader';
import RichText from '@/components/RichText';
import Question from '@/components/Question';
import Nodata from '@/components/Nodata';
import DataModal from '@/components/DataModal';
import Avatar from '@/components/Avatar';
import CoursewarePlayVideoChapter from '@/components/play/CoursewarePlayVideoChapter';


import BasicSettingDao  from '@/../public/static/js/dao/BasicSettingDao';
import CoursewareManageDao  from '@/../public/static/js/dao/CoursewareManageDao';
import VideoManageDao  from '@/../public/static/js/dao/VideoManageDao';
import SystemInvokingDao  from '@/../public/static/js/dao/SystemInvokingDao';
import ClientDao  from '@/../public/static/js/dao/ClientDao';
import QuestionUtils from '@/../public/static/js/QuestionUtils';
import MediaUtils from '@/../public/static/js/MediaUtils';
import filters from '@/../public/static/js/filters';
import '@/../public/static/lib/axios.rest';

Vue.config.productionTip = false;
Vue.component('SearchCard', SearchCard);
Vue.component('ActionButtons', ActionButtons);
Vue.component('FileUploader', FileUploader);
Vue.component('RichText', RichText);
Vue.component('Question', Question);
Vue.component('Nodata', Nodata);
Vue.component('DataModal', DataModal);
Vue.component('Avatar', Avatar);
Vue.component('CoursewarePlayVideoChapter', CoursewarePlayVideoChapter);

// [3] 注册全局过滤器
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key]);
});

Vue.prototype.$BasicSettingDao = BasicSettingDao;
Vue.prototype.$CoursewareManageDao = CoursewareManageDao;
Vue.prototype.$VideoManageDao = VideoManageDao;
Vue.prototype.$SystemInvokingDao = SystemInvokingDao;
Vue.prototype.$ClientDao = ClientDao;
Vue.prototype.$QuestionUtils = QuestionUtils;
Vue.prototype.$MediaUtils = MediaUtils;

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');
